export const FirstLetter = (word: string) => {
  const n = word.split(' ');
  const secondWord = n[n.length - 1];

  return `${word.charAt(0)}${secondWord.charAt(0)}`;
};
